/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scene-node.vue?vue&type=template&id=188a74ca&scoped=true&"
import script from "./scene-node.vue?vue&type=script&lang=js&"
export * from "./scene-node.vue?vue&type=script&lang=js&"
import style0 from "./scene-node.vue?vue&type=style&index=0&id=188a74ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188a74ca",
  null
  
)

export default component.exports